<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="farmingon" title="Solution" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                Smart Farm Solution
            </template>
            <tit-wrap-large>
                <b>FarmingON Series</b> <br class="d-none d-lg-block" />that measures the growth environment <br class="d-none d-lg-block" />of crops as the foundation for data agriculture
                <template #text>You can easily install this user-friendly FarmingON in your desired location. <br class="d-none d-lg-block" />You can monitor the data collected from the growth environment of crops in real time via the mobile app and web browser.</template>
            </tit-wrap-large>

            <v-img max-width="432" :aspect-ratio="432 / 596" src="/images/sub/solution/smartfarm/farmingon-img.png" class="mx-auto" data-aos="fade" data-aos-delay="100" />
        </page-section>

        <v-container>
            <v-divider class="grey lighten-3" />
        </v-container>

        <page-section id="farmingon1">
            <page-section class="page-section--sm py-0">
                <template #pageSectionImmersive>
                    <v-row class="mx-n20px my-n10px mx-md-n30px my-md-n20px">
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-left" data-aos-delay="200">
                            <v-card rounded="" color="grey lighten-5">
                                <v-responsive :aspect-ratio="570 / 456" content-class="d-flex pa-20px">
                                    <v-img max-width="256" :aspect-ratio="256 / 288" src="/images/sub/solution/smartfarm/farmingon-img2.png" class="ma-auto" />
                                </v-responsive>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-right" data-aos-delay="200">
                            <div class="mt-md-24px">
                                <tit-wrap-sprout>
                                    FarmingON
                                    <template #text>
                                        Real-time greenhouse crop growth environment monitoring system
                                    </template>
                                </tit-wrap-sprout>

                                <txt-item titleClass="w-md-140px">
                                    <template #title>Measurement items</template>
                                    Temperature, humidity, CO2, and soil temperature
                                </txt-item>
                                <txt-item titleClass="w-md-140px">
                                    <template #title>Applications</template>
                                    Greenhouse crops such as bell peppers, cucumbers, tomatoes, and strawberries
                                </txt-item>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-card rounded="" color="grey lighten-5" data-aos="fade" data-aos-delay="100">
                        <v-responsive :aspect-ratio="1200 / 770" content-class="d-flex align-center justify-center">
                            <div class="pa-30px pa-md-40px px-lg-80px">
                                <v-img max-width="800" :width="$vuetify.breakpoint.lgAndUp ? '800' : ''" :aspect-ratio="800 / 376" src="/images/sub/solution/smartfarm/farmingon-img3.png" class="mx-auto" />
                                <div class="pt-30px pt-md-40px pt-lg-60px">
                                    <tit-wrap-small>
                                        Easy and simple real-time monitoring via both the Internet and mobile device
                                        <template #text>This IoT system lets you monitor crop growth environment data remotely via the Internet or mobile device.</template>
                                    </tit-wrap-small>
                                </div>
                            </div>
                        </v-responsive>
                    </v-card>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-row justify="center">
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="100">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/smartfarm/farmingon-img4.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                Registered Patent
                                <template #text>
                                    Growth Environment Measurement Device
                                </template>
                            </tit-wrap-small>
                        </v-col>
                    </v-row>
                </template>
            </page-section>
        </page-section>

        <page-section id="farmingon2" class="grey lighten-5">
            <page-section class="page-section--sm py-0">
                <template #pageSectionImmersive>
                    <v-row class="mx-n20px my-n10px mx-md-n30px my-md-n20px">
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-left" data-aos-delay="200">
                            <v-card outlined rounded="">
                                <v-responsive :aspect-ratio="570 / 456" content-class="d-flex pa-20px">
                                    <v-img max-width="448" :aspect-ratio="448 / 208" src="/images/sub/solution/smartfarm/farmingon-img5.png" class="ma-auto" />
                                </v-responsive>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-right" data-aos-delay="200">
                            <div class="mt-md-24px">
                                <tit-wrap-sprout>
                                    FarmingON2
                                    <template #text>
                                        Monitors the growth environment and root zones of greenhouse crops in real time
                                    </template>
                                </tit-wrap-sprout>

                                <txt-item titleClass="w-md-140px">
                                    <template #title>Measurement items of the main body</template>
                                    Temperature, humidity, CO2, root zone measurement, and drainage pH
                                </txt-item>
                                <txt-item titleClass="w-md-140px letter-spacing-n02">
                                    <template #title>Measurement items of probe sensors</template>
                                    Medium temperature, medium humidity, and medium EC
                                </txt-item>
                                <txt-item titleClass="w-md-140px">
                                    <template #title>Applications</template>
                                    Greenhouse crops such as bell peppers, cucumbers, tomatoes, and strawberries
                                </txt-item>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-card outlined rounded="" data-aos="fade" data-aos-delay="100">
                        <v-responsive :aspect-ratio="1200 / 770" content-class="d-flex align-center justify-center">
                            <div class="pa-30px pa-md-40px px-lg-80px">
                                <v-img max-width="800" :width="$vuetify.breakpoint.lgAndUp ? '800' : ''" :aspect-ratio="800 / 376" src="/images/sub/solution/smartfarm/farmingon-img6.png" class="mx-auto" />
                                <div class="pt-30px pt-md-40px pt-lg-60px">
                                    <tit-wrap-small>
                                        Easy and simple real-time monitoring via both the Internet and mobile device
                                        <template #text>This IoT cultivation environment monitoring system helps you understand the growth environment and root zones of greenhouse crops at a glance. greenhouse crop growth environment and root zones.</template>
                                    </tit-wrap-small>
                                </div>
                            </div>
                        </v-responsive>
                    </v-card>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-row justify="center">
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="100">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/smartfarm/farmingon-img7.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                Registered Patent
                                <template #text>
                                    Method and Apparatus for Measuring the State of Medium in Nutriculture
                                </template>
                            </tit-wrap-small>
                        </v-col>
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="200">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/smartfarm/farmingon-img8.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                Registered in the Agricultural Machinery List
                                <template #text>
                                    Medium Measurement Device
                                </template>
                            </tit-wrap-small>
                        </v-col>
                    </v-row>
                </template>
            </page-section>
        </page-section>

        <page-section id="farmingon-portfolio" class="page-section--last">
            <template #title>
                Portfolio
            </template>

            <div class="tabs-wrap">
                <v-tabs v-model="tab" hide-slider show-arrows centered center-active class="v-tabs--btn">
                    <u-tab>FarmingON</u-tab>
                    <u-tab>FarmingON2</u-tab>
                </v-tabs>
            </div>

            <template #pageSectionImmersive>
                <div style="max-width:1480px" class="mx-auto px-12px">
                    <v-tabs-items v-model="tab" touchless>
                        <v-tab-item transition="fade-transition" reverse-transition="fade-transition">
                            <farmingon1-slide />
                        </v-tab-item>
                        <v-tab-item transition="fade-transition" reverse-transition="fade-transition">
                            <farmingon2-slide />
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </template>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";
import TitWrapSprout from "@/components/dumb/tit-wrap-sprout.vue";
import TxtItem from "@/components/dumb/txt-item.vue";
import UTabs from "@/components/dumb/u-tabs.vue";
import UTab from "@/components/dumb/u-tab.vue";
import Farmingon1Slide from "@/pages/client/sub/solution/Farmingon1Slide.vue";
import Farmingon2Slide from "@/pages/client/sub/solution/Farmingon2Slide.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TitWrapSmall,
        TitWrapLarge,
        TitWrapSprout,
        TxtItem,
        UTabs,
        UTab,
        Farmingon1Slide,
        Farmingon2Slide,
    },
    props: {},
    data() {
        return {
            tab: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
